module.exports = __webpack_public_path__ + "223c5caeb97e8dda8c69b10a5789dbba.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/mask-snorkel.png
// module id = 1860
// module chunks = 0